<button nz-button nzType="default"   style="margin-bottom: 20px;" (click)="openAddLink()">
    <nz-icon nzType="plus" />
    Link
</button>

<nz-table [nzData]="projectLinks" [nzBordered]="false" [nzSize]="'small'" [nzFrontPagination]="false"
[nzShowPagination]="false">
    <thead>
      <tr>
        <th>Name</th>
        <th  style="width:200px">Link</th>
        <th>Remove</th>
        <th>Created At</th>
        <th>Created By</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of projectLinks">
        <td>{{ data?.name }}</td>
        <td   >
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" style="display:inline-block;width:250px;white-space: wrap; overflow: hidden; text-overflow: ellipsis;;">
            {{ data?.url }}
          </a>
        </td>
        <td>
          <button nz-button nzDanger nzType="text" nz-popconfirm nzPopconfirmPlacement="bottom" nzPopconfirmTitle="Are you sure delete this item?" (nzOnConfirm)="removeRow(data?.id)">
            <i nz-icon nzType="delete"></i> Remove
          </button>
        </td>
        <td>{{ data.created_at | date: 'yyyy-MM-dd' }}</td>
        <td>{{ getUserName(data?.created_by) }}</td>
      </tr>
    </tbody>
  </nz-table>

  <app-links [isVisible]="isVisibleAddLink" (isnotVisible)="closeAddLinkEvent($event)"
   (linkDetail)="setLinkDetails($event)" (linksChanged)="onLinksChanged($event)"></app-links>
